import React, { useState } from 'react';
import styles from './index.module.scss';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers';
import * as yup from 'yup';
import { Error } from 'components/message/Error';
import ActionButton from 'components/ActionButton';
import 'react-datepicker/dist/react-datepicker.css';
import { createRoute } from 'services';
import { showError } from 'utils';
import { ICreateRoute } from 'interfaces/route';

const validationSchema = yup.object().shape({
  name: yup.string().required(),
});

type FormData = {
  name: string;
  comment: string;
  date: string;
};

const CreateRoute = props => {
  const [deliveryDateTimeStart, setDeliveryDateTimeStart] = useState<any>(moment().toISOString());
  const [deliveryDateTimeEnd, setDeliveryDateTimeEnd] = useState<any>(moment().toISOString());
  const [loading, setLoading] = useState<boolean>(false);
  const {
    register,
    handleSubmit,
    errors,
  } = useForm<FormData>({ resolver: yupResolver(validationSchema) });

  const createRouteFn = handleSubmit(async (values: Record<string, any>) => {
    const { name, comment } = values;
    const params: ICreateRoute={
      name,
      comment,
      deliveryDateTime: deliveryDateTimeStart,
      deliveryEndDateTime: deliveryDateTimeEnd,
    };
    setLoading(true);
    try {
      const response = await createRoute(params);
      props.history.replace(`/routes/${response.id}`);
    } catch (e) {
      showError(e);
    } finally {
      setLoading(false);
    }
  });

  return (
    <div className={styles['main-container']}>
      <div className={styles['header']}>
        <div className={styles['heading']}>Create a New Route</div>
      </div>
      <div className={styles['inputs-section']}>
        <div className={`row`}>
          <div className={`col-md-6 col-lg-12 col-sm-12 mb-3`}>
            <div className={styles['label']}>Name</div>
            <input
              name={'name'}
              ref={register}
              className={'form-control'}
              disabled={loading}
            />
            {errors.name && <Error message={errors.name.message} />}
          </div>
          <div className={`col-md-6 col-lg-4 mb-3 col-sm-12`}>
            <div className={styles['label']}>Delivery Date Start</div>
            <div className={styles['date-picker']}>
              <DatePicker
                wrapperClassName="w-100"
                className={'form-control'}
                showTimeInput
                timeInputLabel="Time:"
                dateFormat={'MM/dd/yyyy hh:mm aa'}
                disabled={loading}
                selected={moment(deliveryDateTimeStart).toDate()}
                onChange={(e: any) => setDeliveryDateTimeStart(moment(e).toISOString())}
              />
            </div>
          </div>
          <div className={`col-md-6 col-lg-4 mb-3 col-sm-12`}>
            <div className={styles['label']}>Delivery Date End</div>
            <div className={styles['date-picker']}>
              <DatePicker
                wrapperClassName="w-100"
                className={'form-control'}
                showTimeInput
                timeInputLabel="Time:"
                dateFormat={'MM/dd/yyyy hh:mm aa'}
                disabled={loading}
                selected={moment(deliveryDateTimeEnd).toDate()}
                onChange={(e: any) => setDeliveryDateTimeEnd(moment(e).toISOString())}
              />
            </div>
          </div>
        </div>
        <div className={styles['input-group']}>
          <div className={styles['label']}>Comment</div>
          <textarea
            name={'comment'}
            ref={register}
            className={'form-control'}
            disabled={loading}
          />
        </div>
      </div>
      <div className={styles['footer']}>
        <ActionButton
          text={'Cancel'}
          active={!loading}
          isLoading={false}
          onClick={() => props.history.goBack()}
          customClass={styles['cancel']}
        />
        <ActionButton
          text={'Create Route'}
          active={!loading}
          isLoading={loading}
          onClick={createRouteFn}
        />
      </div>
    </div>
  );
};

export { CreateRoute };